import ConsumerPrivacyModal from 'components/GlobalModals/ConsumerPrivacyModal/ConsumerPrivacyModal';
import { withConsumerPrivacyModalProps } from 'viewModel/globalModals/consumerPrivacyModal/withConsumerPrivacyModalProps';

export default withConsumerPrivacyModalProps(ConsumerPrivacyModal);
